module.exports = __webpack_public_path__ + "img/personaje-1.d2bb4b31.png";